import Button from "../../../common/components/button";
import loginLogo from "../../../common/assets/images/logo.png";
import { ReactComponent as ReadPassword } from "../../assets/icons/readPassword.svg";
import { ReactComponent as UnreadPassword } from "../../assets/icons/unreadPassword.svg";
import { useState } from "react";
import { usePostLogin } from "../../../common/hooks/console/usePostLogin";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../common/components/spinner";

const Login = () => {
    const [m_id, setMId] = useState("");
    const [m_password, setMPassword] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [focusedField, setFocusedField] = useState<string | null>(null);
    const [idError, setIdError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const navigate = useNavigate();

    const { mutate, isPending } = usePostLogin();

    const handleLogin = () => {
        let hasError = false;
        if (!m_id.trim()) {
            setIdError(true);
            hasError = true;
        }
        if (!m_password.trim()) {
            setPasswordError(true);
            hasError = true;
        }
        if (hasError) return;
        mutate(
            { m_id, m_password },
            {
                onSuccess: response => {
                    // 지점계정은 본점 콘솔을 쓸 수 없다. 전체 새로고침이어야 인증 스토어 키가 지점용으로 잡힌다
                    if (response.data.m_level === 6) {
                        window.location.href = "/branch/transaction";
                        return;
                    }
                    navigate("/console/transaction");
                },
                onError: () => {
                    setLoginError(true);
                },
            },
        );
    };
    const togglePasswordVisibility = () => {
        setPasswordVisible(prev => !prev);
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            handleLogin();
        }
    };

    return (
        <div className="bg-[#F8F9F7] pt-24 h-screen flex items-center justify-center flex-col">
            {isPending && <Spinner />}
            <div className="shadow-2xl shadow-[#7090B01F] w-[600px] h-[720px] bg-white py-[100px] px-5 gap-12 items-center flex flex-col rounded-[32px] border border-gray4">
                <style>
                    {`
                        input:-webkit-autofill,
                        input:-webkit-autofill:hover, 
                        input:-webkit-autofill:focus, 
                        textarea:-webkit-autofill, 
                        textarea:-webkit-autofill:hover, 
                        textarea:-webkit-autofill:focus, 
                        select:-webkit-autofill, 
                        select:-webkit-autofill:hover, 
                        select:-webkit-autofill:focus {
                            -webkit-box-shadow: 0 0 0px 1000px white inset !important;
                            box-shadow: 0 0 0px 1000px white inset !important;
                            background-color: white !important;
                            color: #000 !important;
                        }
                    `}
                </style>
                <div className="flex flex-col items-center gap-4">
                    <img className="w-[216px]" alt="loginLogo" src={loginLogo} />
                    <p className="text-[#273219] text-[28px] font-bold">관리자 페이지</p>
                </div>
                <div className="w-[400px] flex flex-col gap-6">
                    <div className="flex flex-col gap-2">
                        <div
                            className={`flex flex-col gap-2 py-3 px-5 rounded-2xl border ${
                                idError || loginError
                                    ? "border-error"
                                    : focusedField === "username"
                                      ? "border-[#163F75]"
                                      : "border-grayicon"
                            }`}
                        >
                            <p className="text-primary1 text-sm font-bold">아이디</p>
                            <input
                                className="placeholder:text-grayicon text-lg focus:outline-none focus:ring-0 "
                                placeholder="아이디를 입력해주세요"
                                value={m_id}
                                onChange={e => {
                                    setMId(e.target.value);
                                    setIdError(false);
                                    setLoginError(false);
                                }}
                                onKeyDown={handleKeyDown}
                                onFocus={() => setFocusedField("username")}
                                onBlur={() => setFocusedField(null)}
                            />
                        </div>
                        <div
                            className={`flex flex-col gap-2 py-3 px-5 rounded-2xl border ${
                                passwordError || loginError
                                    ? "border-error"
                                    : focusedField === "password"
                                      ? "border-[#163F75]"
                                      : "border-grayicon"
                            }`}
                        >
                            <p className="text-primary1 text-sm font-bold">비밀번호</p>
                            <div className="flex justify-between bg-white">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    className="placeholder:text-grayicon bg-white w-full text-lg focus:outline-none focus:ring-0"
                                    placeholder="비밀번호를 입력해주세요"
                                    value={m_password}
                                    onChange={e => {
                                        setMPassword(e.target.value);
                                        setPasswordError(false);
                                        setLoginError(false);
                                    }}
                                    onKeyDown={handleKeyDown}
                                    onFocus={() => setFocusedField("password")}
                                    onBlur={() => setFocusedField(null)}
                                />
                                {passwordVisible ? (
                                    <ReadPassword className="cursor-pointer ml-2" onClick={togglePasswordVisibility} />
                                ) : (
                                    <UnreadPassword className="cursor-pointer ml-2" onClick={togglePasswordVisibility} />
                                )}
                            </div>
                        </div>
                        {loginError && <p className="text-error">계정 정보가 일치하지 않습니다.</p>}
                    </div>
                    <Button className="w-full" size="L" status="regist" onClick={handleLogin}>
                        로그인
                    </Button>
                </div>
            </div>
            <p className="text-gray3 text-sm pt-16 mb-32">Copyright © 2025. (주)고려원예</p>
        </div>
    );
};
export default Login;
